import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { AuthRoutes } from "./pages/auth/routes";
import {
  DashboardRoutes,
  FullLayoutRoutes,
  FullLayoutRoutesAnimateFromRight,
} from "./pages/dashboard/routes";
import { AuthProvider } from "./context/auth";

export const routes = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      ...AuthRoutes,
      ...DashboardRoutes,
      ...FullLayoutRoutes,
      ...FullLayoutRoutesAnimateFromRight,
    ],
  },
]);
